import { userBrowserDetails } from "../util/checkDeviceAndBrowserType";
export function checkIncognito(): Promise<boolean> {
    return new Promise((resolve) => {
        userBrowserDetails().then((data) => {
            resolve(data?.inCognito ?? false);
        });
    });
}
export async function getWorker(): Promise<Worker | null> {
    const data = await userBrowserDetails();
    if (data?.inCognito) return null;
    const webWorkerUrl = window.location.origin + '/brand/_assets/js/webWorker.js';
    return new Worker(webWorkerUrl);
  }